import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';
import { useOrderFillsCapsuleConfigSlice } from '../store/configslice';

export default function OrderFillsCapsuleSettings() {
    const { config: configSliceConfig, dispatchConfigChanged } =
        useOrderFillsCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged
    );
    const config = configSliceConfig;

    return (
        <div className="OrderFillsCapsuleSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetSettingsCheckboxValueEditor
                propertyName="includePreviousDaysFills"
                config={config!}
                label="Show portion of order filled in previous days' trading"
                onChange={debouncedApplyWidgetConfigChange}
            />

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
